module.exports = __webpack_public_path__ + "static/media/reviews.248291f3.248291f3.webp";